export var OnCloseInlineComposeActionName = 'onCloseInlineCompose';
export var OnSuccessfulSendFromInlineComposeName = 'OnSuccessfulSendFromInlineCompose';
export var UpdateInternetMessageIdName = 'UpdateInternetMessageId';
export var CloseComposeActionName = 'closeCompose';
export var openComposeActionName = 'openCompose';
export var moveComposeToPopoutActionName = 'moveComposeToPopout';
//# sourceMappingURL=index.js.map